import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { AllLawyerCommentariesModal } from '../../../modals/entity-lists/AllLawyerCommentariesModal';
import { fetchCommentaries } from '../../lawyer.api';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { LawyerCommentarySelection } from './LawyerCommentarySelection';
import { Commentary } from '../../../commentary/commentary.types';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../user/user.types';
import {
  EntityBlock,
  EntityBlockTitle,
  EntityBlockSubtitle,
} from '../../../entity/components/EntityBlockComponents';
import { withUser } from '../../../user/UserContext';
import { withLawyer } from '../LawyerContext';
import { LawyerContextType } from '../lawyer.types';
import styles from './lawyer_commentaries.module.scss';
import { SeeMore } from '../../../components/see-more/SeeMore';

type Props = WithRestrictedModalProps &
  WithModalProps &
  UserContextType &
  LawyerContextType;

type State = {
  commentaries: Array<Commentary>;
  totalNumber: number;
};

export class RawLawyerCommentaries extends Component<Props, State> {
  state: State = {
    commentaries: [],
    totalNumber: 0,
  };

  source = 'lawyer_articles';

  id = 'lawyer-commentaries';

  async componentDidMount() {
    const full = false;
    const userGeneratedOnly = false;
    const {
      lawyerInfos: { lawyerId },
    } = this.props;

    const { commentaries, totalNumber } = (
      await fetchCommentaries(lawyerId, full, userGeneratedOnly)
    ).data;

    if (commentaries.length) {
      window.dispatchEvent(
        new CustomEvent('createNav', {
          detail: this.id,
        }),
      );
    }

    this.setState({ commentaries, totalNumber });
  }

  handleSeeMoreLawyerCommentaries = () => {
    const {
      accessPremium,
      openModal,
      openRestrictedModal,
      lawyerInfos: { lawyerId },
    } = this.props;
    if (accessPremium) {
      openModal(modalProps => (
        <AllLawyerCommentariesModal
          lawyerId={lawyerId}
          {...modalProps}
          source="custom-source"
          decision={{ title: 'custom-data' }}
        />
      ));
    } else {
      openRestrictedModal(this.source);
    }
    doctrineAnalytics('Lawyer MoreCommentariesClicked');
  };

  render() {
    const { commentaries, totalNumber } = this.state;
    const { lawyerName } = this.props;
    const { length: commentariesNumber } = commentaries;
    const remainingArticles = totalNumber - commentariesNumber;
    const commentariesLimited = commentaries.slice(0, commentariesNumber);

    if (!commentaries || !commentaries.length) return null;

    return (
      <div>
        <h2 id={this.id} className="entity__section-title">
          <FormattedMessage id="lawyer-commentaries/LawyerCommentaries.tsx/1" />{' '}
          <span className="entity__section-title--regular">
            <FormattedMessage id="lawyer-commentaries/LawyerCommentaries.tsx/2" />{' '}
            {lawyerName}
          </span>
        </h2>
        <EntityBlock>
          <EntityBlockTitle>
            <FormattedMessage id="lawyer-commentaries/LawyerCommentaries.tsx/3" />
          </EntityBlockTitle>
          <EntityBlockSubtitle />
          <div className={styles.commentaries}>
            {commentariesLimited.map((commentary, index) => (
              <LawyerCommentarySelection
                key={index.toString()}
                commentary={commentary}
                index={index}
              />
            ))}
            {remainingArticles > 0 && (
              <SeeMore onClick={this.handleSeeMoreLawyerCommentaries}>
                <FormattedMessage
                  id="lawyer-commentaries/LawyerCommentaries.tsx/4"
                  values={{ count: remainingArticles }}
                />
              </SeeMore>
            )}
          </div>
        </EntityBlock>
      </div>
    );
  }
}

export const LawyerCommentaries = withModal(
  withRestrictedModal(withUser(withLawyer(RawLawyerCommentaries))),
);
